import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
import $ from "jquery";

/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("Campagne Marketing JS en cours ...");
        super.connect();
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });

            // Appel de la fonction avec un préfixe d'ID spécifique pour les éléments
            this.handleSidebarScroll("campagne_marketing_");
        }
        // Gestion du chargement initial
        window.onload = this.initializeMessages;
    }

    initializeMessages() {
        console.log("Initializing messages...");

        const messages = document.querySelectorAll(".fx-text-box[data-auto-dismiss='true']");

        messages.forEach((message) => {
            const duration = parseInt(message.dataset.autoDismissDuration || "5000", 10);
            const progressBar = message.querySelector(".fx-text-box-progress");
            let startTime = Date.now(); // Temps de démarrage 
            let elapsedTime = 0; // Temps écoulé
            let timerId; // ID du timeout

            // Fonction pour démarrer la progression
            const startProgress = () => {
                const remainingTime = duration - elapsedTime;
                progressBar.style.transition = `width ${remainingTime}ms linear`;
                progressBar.style.width = "100%";

                timerId = setTimeout(() => {
                    message.style.opacity = "0";
                    setTimeout(() => {
                        message.remove();
                        console.log("Message removed.");
                    }, 500);
                }, remainingTime);
            };

            // Fonction pour mettre en pause la progression
            const pauseProgress = () => {
                clearTimeout(timerId); // Arrête le timeout
                elapsedTime += Date.now() - startTime; // Calcule le temps écoulé
                progressBar.style.transition = "none"; // Désactive la transition
                const currentWidth = (elapsedTime / duration) * 100; // Largeur actuelle
                progressBar.style.width = `${currentWidth}%`;
            };

            // Ajouter les événements pour pause/reprise
            message.addEventListener("mouseenter", () => {
                console.log("Progress paused.");
                pauseProgress();
            });

            message.addEventListener("mouseleave", () => {
                console.log("Progress resumed.");
                startTime = Date.now(); // Redémarre le calcul du temps
                startProgress();
            });

            // Initialiser la progression
            startTime = Date.now();
            startProgress();
        });
    }

}